<template>
    <div v-if="dados">
        <div class="form-row">
            <div class="col col-12 col-md-8">
                <az-periodo
                    v-model="filtros" 
                    :sync="true"
                    @sync="load()" />
            </div>
            <div class="col col-12 col-md-4">
                <az-input
                    icon="fa fa-search"
                    v-model="search">
                    <template v-slot:buttonposb>
                        <print-export printid="lista-mov-print"/>
                    </template>
                </az-input>
            </div>
        </div>
        <div class="progress mt-1 mb-1">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div id="lista-mov-print">
            <cabecalho-generico titulo="Movimentações do Material">
                <div>#{{ material.id_estoque_item }}</div>
                <div>{{ material.search }}</div>
            </cabecalho-generico>

            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Data</th>
                        <th>Usuário</th>
                        <th>Tipo</th>
                        <th v-if="material && material.fl_controla_lote">Lote</th>
                        <th>Doc</th>
                        <th class="text-right">Qtd</th>
                        <template v-if="saldo !== null">
                            <th class="text-right">Preço</th>
                            <th class="text-right">Saldo</th>
                            <th class="text-right">Valor</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(mov, imx) in lista" :key="imx" class="small" :class="mov.in_fator_saldo < 0 ? 'table-danger' : 'table-success'">
                        <td>
                            <a href="#" @click.prevent="abrir_atalho(mov.link.atalho)" v-if="mov.link && mov.link.atalho" class="card-link">
                                #{{ mov.id_estoque_movimentacao }}    
                            </a>
                            <span v-else>
                                #{{ mov.id_estoque_movimentacao }}
                            </span>
                        </td>
                        <td>
                            <div title="Movimentação">
                                <i class="fa-regular fa-calendar-check fa-fw mr-1"></i>
                                {{ $util.getFormatDate(mov.dt_movimentacao) }}
                                {{ mov.dt_movimentacao.substr(11,5) }}
                            </div>
                            
                            <div title="Criação">
                                <i class="fa-regular fa-calendar-plus fa-fw mr-1"></i>
                                {{ $util.getFormatDate(mov.dt_criacao) }}
                                {{ mov.dt_criacao.substr(11,5) }}
                            </div>
                        </td>
                        <td>{{ mov.usuario.st_login }}</td>
                        <td>
                            <a href="#" @click.prevent="filtrar(mov.tipo.search)">
                                <span v-if="mov.id_estoque_tipo_movimentacao == 2 && mov.in_fator_saldo > 0">Devolução</span>
                                <span v-else>
                                    {{ mov.tipo.search }}
                                    <span v-if="mov.id_marcacao">
                                        Paciente
                                    </span>
                                </span>
                            </a>

                            <div v-if="mov.complemento">
                                {{ mov.complemento }}
                            </div>
                            
                            <div v-if="mov.st_observacao">
                                {{ mov.st_observacao }}
                            </div>
                        </td>
                        <td v-if="material && material.fl_controla_lote">{{ mov.st_lote }}</td>
                        <td>{{ mov.st_doc }}</td>
                        <td class="text-right">
                            {{ mov.in_quantidade }}
                            <span v-if="mov.in_fator_saldo > 0" class="text-success">
                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                            </span>
                            <span v-else-if="mov.in_fator_saldo < 0" class="text-danger">
                                <i class="fa fa-minus-circle" aria-hidden="true"></i>
                            </span>
                        </td>
                        <template v-if="saldo !== null">
                            <td class="text-right">{{ $util.formatMoeda(mov.dc_valor, 6) }}</td>
                            <td class="text-right">{{ mov.saldo_qtd }}</td>
                            <td class="text-right">
                                <span v-if="!isNaN(mov.saldo_valor)">
                                    {{ $util.formatMoeda(mov.saldo_valor) }}
                                </span>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <pre class="alert alert-info" v-if="1==0">{{ dados }}</pre>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return { 
            dados: null, 
            saldo: null, 
            material: null, 
            id_estoque_local: "", 
            search: "", 
            filtros: { 
                inicio: "",
                fim: "",
                periodo: "m",
            }
        }
    },

    components: { 
        AzInput, 
        AzPeriodo,
        PrintExport, 
        CabecalhoGenerico, 
    },

    props: ['lote'],
    
    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => ( !this.lote || item.st_lote == this.lote ) && 
                ( !this.search || reg.test(JSON.stringify(item))) );
        }
    },

    methods: { 
        filtrar (texto) { 
            texto = '"' + texto + '"';
            this.search = ( this.search == texto ? '' : texto );
        },

        abrir_atalho(atalho) { 
            $(".modal").modal("hide");
            this.$router.push({ path: atalho })
        },

        load() { 
            this.$util.load(this, { 
                service: 'estoque_movimentacoes',
                func: 'index',
                parms: { 
                    id_estoque_item: this.material.id_estoque_item, 
                    id_estoque_local: this.id_estoque_local,
                    referencia: this.data, 
                    saldo: this.saldo, 
                    ficha: true, 
                    ...this.filtros, 
                    lote: this.lote, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        abrir(item, id_estoque_local, data, saldo = null) { 
            this.id_estoque_local = id_estoque_local;
            this.material = item;
            this.saldo = saldo;
            this.dados = null;
            this.data = data;

            this.load();
        }
    }
}
</script>